<div
  class="tooltip-box"
  *ngIf="viewData && data?.isVisible && !dismissed"
  [class]="'tip-' + viewData.tipDirection + (viewData.arrowAlign && viewData.arrowAlign !== 'center' ? ' arrow-' + viewData.arrowAlign : '')"
>
  <button class="tooltip-close" (click)="close()">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>
  <div class="tooltip-content">
    <svg class="tooltip-icon" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="16" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
    <div class="tooltip-text" [innerHTML]="viewData.text | translate"></div>
  </div>
</div>
